import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import { Layout, BodySection } from "../Layout";
import styled, { ThemeContext } from "styled-components";
import { VideoMeta, PostShowSurvey, Hero } from "Components";

export const PostShow = ({ event, token, onSuccess }) => {
  const themeContext = useContext(ThemeContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  let headerLogo = `${api}/o/${event?.logos?.header?.path}?alt=media`;
  headerLogo = `/assets/${event?.logos?.header?.path}`;
  // const footerLogo = `${api}/o/${event?.logos?.footer?.path}?alt=media`;
  const overlayImg = `${api}/o/${event?.postShow?.overlayImage?.path}?alt=media`;

  return (
    <Layout
      // header
      headerShowLogo={true}
      headerLogo={headerLogo}
      headerSecondaryText={event.header}
      // hero
      heroContent={
        <HeroWrapper>
          <HeroLeft>
            <Hero
              heroContent={
                <HeroSection token={token}>
                  <ThankYouHeader>
                    {token
                      ? event?.postShow?.thankYouHeader
                      : "Sorry We Missed You"}
                  </ThankYouHeader>
                  <ThankYouBody>
                    {token
                      ? event?.postShow?.thankYouBody
                      : ReactHtmlParser(
                          `Join us next time! Visit <a href="https://www.fordmusic.com" target="_blank" rel="noopener noreferrer">www.fordmusic.com</a> for more information about upcoming shows`
                        )}
                  </ThankYouBody>
                  {event?.postShow?.overlayImage?.path && (
                    <OverlayImage src={overlayImg} />
                  )}
                </HeroSection>
              }
            />
            <VideoMeta />
          </HeroLeft>

          {token && (
            <HeroRight>
              <PostShowSurvey fields={event?.register?.fields} token={token} />
            </HeroRight>
          )}
        </HeroWrapper>
      }
      heroPadding={event?.show?.chatActive ? 0 : "56.25%"}
      videoStyle={
        event?.show?.chatActive
          ? { position: "relative", width: "100%" }
          : undefined
      }
      // heading
      heading={event?.postShow?.heading}
      // main
      subHeading={event?.postShow?.subHeading}
      noPadding
      // footer
      footerShow={false}
      footerShowLogo
      footerLogo={headerLogo}
      footerShowText
      footerPrivacyPolicy={event?.footer}
    >
      {event?.postShow?.body ? (
        <BodySection>{ReactHtmlParser(event?.postShow?.body)}</BodySection>
      ) : undefined}
    </Layout>
  );
};

const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #102b4e;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
  }
`;

const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeroRight = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    width: 392px;
    flex-shrink: 0;
  }
`;

const HeroSection = styled.div`
  text-align: center;
  padding: 0 30px;
  position: absolute;
  top: ${(props) => (props.token ? "11vw" : "8vw")};
  left: 0;
  right: 0;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    top: ${(props) => (props.token ? "8vw" : "18vw")};
  }
`;

const ThankYouHeader = styled.h1`
  font-size: 10vw;
  color: white;
  font-family: ${(props) => props.theme.fontStacks.header};
  line-height: 1;
  text-transform: uppercase;
  margin-bottom: 2vw;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 7vw;
  }
`;

const ThankYouBody = styled.h4`
  font-size: 4vw;
  color: #ffffff;
  margin: 0;
  text-transform: uppercase;

  a {
    color: #ffffff;
    text-decoration: none;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 2.5vw;
  }
`;

const OverlayImage = styled.img`
  margin-top: ${(props) => props.theme.postShow.overlayImage.marginTop[1]};
  width: ${(props) => props.theme.postShow.overlayImage.width[1]};

  @media only screen and ${(props) => props.theme.maxMedia.small} {
    margin-top: ${(props) => props.theme.postShow.overlayImage.marginTop[0]};
    width: ${(props) => props.theme.postShow.overlayImage.width[0]};
  }
`;
